import React, { useState, useEffect } from 'react';

import { useNavigate, useLocation } from 'react-router-dom';
import SideBar from '../../../src/Components/ClientDashboard/Clientcommon/SideBar';
import Header from '../../../src/Components/ClientDashboard/Clientcommon/Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../../../src/pages/client/client_assets/css/sb-admin-2.min.css';
import '../../../src/pages/client/client_assets/css/common.css';
import '../../../src/pages/client/client_assets/css/responsive.css';
import '../../../src/pages/client/client_assets/css/Configure.css';
import HideText from '../../../src/Components/ClientDashboard/Clientcommon/HidePageText';
import Surveys from '../../../src/Components/ClientDashboard/ClientSurveys/Surveys';
// import Template from '../components/SurveyTemplate/Template';

const SurveysPage = () => 
{


  
  
      const baseClass = 'container-fluid';
      const className = `${baseClass}`;


    const [hasMargin, setHasMargin] = useState(true)

    useEffect(()=>{
        function removeMargin(){
                setHasMargin(false)
        }
        removeMargin()
    })  

    return (
        <div id="page-top">
        <div id="wrapper">
          <SideBar />
          <div id="content-wrapper" className={`d-flex flex-column ${hasMargin ? 'has-margin' : ''}`}>
            <div id="content"  className={className}>
              <Header />
              <Surveys  />
      
            </div>
          </div>
        </div>
        <HideText/>
      </div>
    );
};

export default SurveysPage;